module.exports = __webpack_public_path__ + "img/window (1).f7df2720.png";